export const styles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  zIndex: 999,
};
